import {toJS} from 'mobx';
import {types, applySnapshot, destroy, flow} from 'mobx-state-tree';
import GroupModel from '../models/group-model';
import GroupService from '../services/group-service';

const GroupStore = types.model('GroupStore', {
    groups: types.optional(types.array(GroupModel), []),
    hasLoaded: types.optional(types.boolean, false),
})
    .actions((self) => {
        let isLoadGroupsRunning = false;

        return {
            loadGroups: flow(function* (query) {
                if (self.hasLoaded || isLoadGroupsRunning) return;
                isLoadGroupsRunning = true;

                const groupService = new GroupService();

                const _groups = yield groupService.list(query);

                const cleanedGroups = _groups.map((_group) => ({
                    id: _group.id,
                    name: _group.name,
                    groupId: _group.groupId,
                    attributes: _group.attributes,
                    createdByUserId: _group.createdByUserId,
                    createdAt: _group.createdAt,
                    updatedAt: _group.updatedAt,
                }));

                applySnapshot(self.groups, cleanedGroups);

                self.hasLoaded = true;
                isLoadGroupsRunning = false;
            }),

            addGroup(data) {
                self.groups.push(data);
            },

            updateGroup(groupId, data) {
                const _group = self.findById(groupId);
                if (_group) {
                    _group.update(data);
                }
            },

            removeGroup(groupId) {
                const _group = self.findById(groupId);
                if (_group) {
                    destroy(_group);
                }
            },
        };
    })
    .views((self) => ({
        get list() {
            return toJS(self.groups);
        },

        get listAsOptions() {
            const options = self.groups.map((group) => ({
                id: group.id,
                title: group.name,
            }));
            return toJS(options);
        },

        // Índice por id pelo mesmo motivo do CustomerStore: um computed montado uma vez por action ou
        // reação, em vez de percorrer a lista a cada dispositivo.
        get groupsById() {
            return new Map(self.groups.map((group) => [group.id, group]));
        },
        findById(id) {
            return self.groupsById.get(id);
        },

        findIndex(groupId) {
            return self.groups.findIndex((group) => group.id === groupId);
        },
    }));

export default GroupStore;
